<template>
  <div>
    <div>
      <h4 class="mb-0 d-flex align-items-center">
        <i :class="setting.icon"></i> <span class="ms-2">{{ setting.name }}</span>
      </h4>
      <span class="text-muted small d-block lh-140 mt-1">{{ setting.description }}</span>
    </div>
    <div class="mt-3">
      <HttpFormView :content="{ value: setting.value }" :endpoint="utilities.path('communities/@/modules/@/settings/@', communityId, module, setting.key)" method="put" @success="success">
        <template v-slot:form="{ content, errors, submit, loading }">
          <div class="d-flex align-items-center g-4 flex-nowrap position-relative">
            <div class="w-100 overflow-hidden">
              <FormParameter :parameter="setting.parameter" :title="setting.name" :value="content.value" @update:value="content.value = $event" :errors="errors.value" :search-endpoint="searchableEndpoint"/>
            </div>
            <div v-if="setting.parameter.multiple ? !arraysEqual(content.value, setting.value) : content.value !== setting.value" class="d-flex align-items-center g-3">
              <ButtonView type="normal" color="primary" :disabled="loading" @click="submit()">
                <i class="fas fa-floppy-disk"></i>
              </ButtonView>
              <ButtonView type="normal" color="secondary" :disabled="loading" @click="content.value = setting.value">
                <i class="fas fa-times"></i>
              </ButtonView>
            </div>
            <SpinnerView color="primary" :active="loading"/>
          </div>
          <InputErrorsView :errors="errors.value"/>
        </template>
      </HttpFormView>
    </div>
  </div>
</template>

<script>
import {ButtonView, InputErrorsView, HttpFormView, utilities, toasts, SpinnerView} from "@/niftybit";
import FormParameter from "@/components/forms/FormParameter.vue";
import localization from "@/localization";

export default {
  name: "Setting",
  components: {SpinnerView, InputErrorsView, HttpFormView, FormParameter, ButtonView},
  emits: ["loading", "reload"],
  props: {
    setting: Object,
    communityId: String,
    module: String
  },
  computed: {
    utilities() {
      return utilities
    },
    searchableEndpoint() {
      return utilities.path("communities/@/modules/@/settings/@/options", this.communityId, this.module, this.setting.key);
    }
  },
  methods: {
    success() {
      this.$emit('reload');
      toasts.create({
        color: "success",
        content: localization.translate("operation_successful")
      });
    },
    arraysEqual(a, b) {
      if (!a || !b) return a === b;
      const bSorted = b.slice().sort();
      return a.length === b.length && a.slice().sort().every(function(value, index) {
        return value === bSorted[index];
      });
    }
  }
}
</script>

<style scoped>

</style>
